import React from "react";
import { Styled } from "./styles";
import withErrorBoundary from "@/components/hoc/withErrorBoundary";
import VerificationForm from "@/components/verifications";
import useQueryVerifications from "@/hooks/queries/useQueryVerifications";
import { CircularProgress } from "@mui/material";

const Verifications: React.FC = () => {
    const { data: verifications, isLoading } = useQueryVerifications();

    if (isLoading || !verifications) {
        return (
            <Styled.Page center={true}>
                <CircularProgress />
            </Styled.Page>
        );
    }

    return (
        <Styled.Page>
            <VerificationForm verifications={verifications} />
        </Styled.Page>
    );
};

export default withErrorBoundary({ component: "Verification Page" })(Verifications);
